import AntdSteps from 'components/AntdSteps'
import { menuData } from 'modules/OnBoarding/menu'
import {
  Container,
  Content,
  Heading,
  SubContainer,
  Wrapper,
} from 'modules/OnBoarding/Style/style'
import Header from 'modules/Page/Components/Partials/Header'
import React, { Fragment, useState } from 'react'

const InstituteOnBoarding = () => {
  const [current, setCurrent] = useState(0)

  return (
    <Fragment>
      <Header isOnboarding={true} />
      <Container>
        <SubContainer column>
          <AntdSteps
            steps={menuData}
            current={current}
            setCurren={setCurrent}
          />
        </SubContainer>
        <Wrapper column>
          <Heading>{menuData[0]?.heading}</Heading>
          <Content></Content>
        </Wrapper>
      </Container>
    </Fragment>
  )
}

export default InstituteOnBoarding
